import { render, staticRenderFns } from "./validation-message.vue?vue&type=template&id=60e1637f"
import script from "./validation-message.vue?vue&type=script&lang=js"
export * from "./validation-message.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports